export const buildInfo = {
  version: __APP_VERSION__,
  commit: __BUILD_COMMIT__,
  release: `${__APP_VERSION__}+${__BUILD_COMMIT__}`,
  gleapCustomData: {
    appVersion: __APP_VERSION__,
    buildCommit: __BUILD_COMMIT__,
  },
} as const;
